// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectNewsSubscribeResponseMessage } from "../../../../Utils/DirectMessages/DirectNewsSubscribeResponseMessage.js"
import { SubscribeNewsGroup } from "../Groups/GroupsImport.js"
export let NewsSubscribeResponseProcessor = function ()
{
    MessageProcessorBase.call(this)
}

NewsSubscribeResponseProcessor.prototype = Object.create(MessageProcessorBase.prototype)

NewsSubscribeResponseProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectNewsSubscribeResponseMessage();

    let subscribeNewsGroups = fieldSet.GetGroups(FieldsFactory.SUBSCRIBE_NEWS_GROUP);
    if (subscribeNewsGroups)
        for (let i = 0; i < subscribeNewsGroups.length; i++)
        {
            let subscribeNewsGroupFieldSet = subscribeNewsGroups[i],
                subscribeNewsGroup = new SubscribeNewsGroup(subscribeNewsGroupFieldSet),
                routeID = subscribeNewsGroup.getRouteId();

            if (routeID)
                message.RouteIdsArr.push(routeID);
        }

    return [message];
}

